import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useNavigate } from "react-router";
// import pipelineImage from "@images/partners/hima/solutions/pipelinemgmt-img.png";
import washingPanel from "@images/partners/power-volt/solutions/washing-panel.png";
import dynaTcag from "@images/partners/dynamox/products/sensors/DynaLogger TcAg.png";
import gateValve from "@images/partners/sciebel/products/gate-valve.png";
import something from "@images/partners/sciebel/something.png";
import clamp from "@images/partners/sciebel/products/clamp.png";

interface SingleBoxProps {
  title: string;
  description?: string;
  image?: string;
  route?: string;
}

const SingleBox: React.FC<SingleBoxProps> = ({
  title,
  description,
  image,
  route,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (route) {
      window.scrollTo(0, 0);
      navigate(route);
    }
  };

  const handleImage = () => {
    if (!image) {
      return `https://placehold.co/300?text=${title}`;
    } else {
      return image;
    }
  };

  return (
    <div className="overflow-hidden rounded-sm bg-white shadow-lg">
      <img
        src={handleImage()}
        alt="Oil & Gas Production"
        className="h-64 w-full object-cover"
      />
      <div className="flex w-full flex-col justify-between space-y-2 p-4">
        <span className="text-lg font-bold text-gray-800">{title}</span>
        <span className="text-sm text-gray-700">{description}</span>
        <hr />
        <div className={`flex w-full items-center justify-end p-1`}>
          <button
            className="flex items-center gap-3 rounded-sm bg-primary-700 px-3 py-2 text-white transition-all hover:bg-primary-800"
            onClick={handleClick}
          >
            Saiba mais
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      </div>
    </div>
  );
};

export const UniversalBoxes: React.FC = () => {
  const BOXES = [
    // {
    //   title: "Pipeline Management 4.0",
    //   image: pipelineImage,
    //   route: "/portfolio#portfolio-previewer?categoria=automacao",
    //   description:
    //     "A solução Pipeline Management Control integra detecção de vazamentos, segurança operacional e cibersegurança em um sistema automatizado e inteligente. Com monitoramento contínuo e resposta imediata a falhas, reduz riscos ambientais e operacionais, garantindo conformidade com os mais altos padrões globais de segurança, como SIL 3 e IEC 62443.",
    // },
    {
      title: "Gate Valve (Válvula Gaveta)",
      image: gateValve,
      route: "/portfolio#portfolio-previewer?categoria=valvulas",
      description:
        "Essencial para controlar o fluxo de líquidos e gases em sistemas de alta pressão. A Válvula Gaveta oferece robustez e confiabilidade, ideal para aplicações industriais exigentes.",
    },
    {
      title: "Atuadores Pneumáticos",
      image: something,
      route: "/portfolio#portfolio-previewer?categoria=atuadores",
      description:
        "Projetados para operar em ambientes agressivos, os Atuadores Pneumáticos garantem alta eficiência e durabilidade, oferecendo controle preciso e confiável em sistemas de automação industrial.",
    },
    {
      title: "Sensores e Gateways Industrial",
      image: dynaTcag,
      route: "/portfolio#portfolio-previewer?categoria=sensores",
      description:
        "Sensores e Gateways Industriais para monitoramento remoto de variáveis críticas em tempo real, garantindo a segurança e eficiência operacional de sistemas industriais.",
    },
    {
      title: "Clamp Hub Connector",
      image: clamp,
      route: "/portfolio#portfolio-previewer?categoria=conexoes",
      description:
        "Projetado para conexões seguras e eficientes em tubulações, o Clamp Hub Connection garante alta resistência mecânica e vedação confiável. Fabricado com materiais de alta qualidade, é ideal para aplicações industriais exigentes, como oleodutos, gasodutos e FPSOs.",
    },
    {
      title: "Serviço de Limpeza de Painéis Elétricos",
      image: washingPanel,
      route: "/portfolio#portfolio-previewer?categoria=paineis",
      description:
        "Serviços especializados de limpeza de painéis elétricos, prevenindo falhas, aumentando a vida útil dos componentes e garantindo a máxima eficiência operacional em sistemas industriais.",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {BOXES.map(({ title, description, image, route }) => (
        <SingleBox
          key={title}
          title={title}
          description={description}
          image={image}
          route={route}
        />
      ))}
    </div>
  );
};
